import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/PackingList/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Commercial Invoice',
    url: '/resources/freight-templates/commercial-invoice',
    fileName: 'commercial_invoice',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Certificate of Origin',
    url: '/resources/freight-templates/certificate-of-origin',
    fileName: 'certificate_of_origin',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Shipper\'s Letter of Instruction',
    url: '/resources/freight-templates/sli',
    fileName: "shipper's_letter_of_instruction",
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "Why can't I just give customs the invoice?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Because the invoice doesn't tell them the physical details. Customs officers need to know the weight and packaging to verify the goods against the risk profile. They need both documents to clear the shipment.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "How do I handle a shipment with hundreds of small items?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Group them. Use a "master" packing list that summarizes the pallets or cartons. You can attach detailed breakdown sheets, but the main page should give a clear overview of the total pieces and weight.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "What makes a packing list 'export ready'?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          It needs to match the actual cargo markings. If the box says "1/50," the packing list better say there are 50 boxes. Include the <a class='${cn('faq__answer-link')}' href='https://www.df-alliance.com/blog/what-are-harmonised-system-hs-codes-in-shipping-'>HS codes</a>, accurate weights, and dimensions.  "
        </p>
      `
    ),
  },
];